/**
 * What the app calls itself.
 *
 * Kept in one place because the name is no longer descriptive of the content:
 * "Gridiron Squares" was accurate while football was the only sport, and
 * became a lie the moment basketball arrived. The name now matches the domain
 * the app is served from, which was always sport-neutral.
 *
 * The repository keeps its original name; this is the product name, and the
 * two are allowed to differ.
 */

export const APP_NAME = 'Squares Pool';

/** Sits under the name on the landing banner. */
export const APP_TAGLINE = 'Football and basketball squares, live';

/** Default title for a pool created by hand, with no fixture to name it. */
export const UNTITLED_GAME = 'New squares pool';
